import {BUY_BUTTON_ENABLE, BUY_BUTTON_DISABLE, BUY_BUTTON_SHOW, BUY_BUTTON_HIDE} from "../Actions/BuyButton.action";

export const buyButton = (state = {disabled: true, hidden: false}, action) => {
    switch (action.type) {
        case BUY_BUTTON_ENABLE:
        case BUY_BUTTON_DISABLE:
        case BUY_BUTTON_SHOW:
        case BUY_BUTTON_HIDE:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
} 
